var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRosterIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-group-work",
    "data-name": "Icon material-group-work",
    d: "M16.5,3A13.5,13.5,0,1,0,30,16.5,13.5,13.5,0,0,0,16.5,3ZM11.1,23.925a3.375,3.375,0,1,1,3.375-3.375A3.376,3.376,0,0,1,11.1,23.925ZM13.125,11.1A3.375,3.375,0,1,1,16.5,14.475,3.376,3.376,0,0,1,13.125,11.1ZM21.9,23.925a3.375,3.375,0,1,1,3.375-3.375A3.376,3.376,0,0,1,21.9,23.925Z",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosterIconGray);
export default __webpack_public_path__ + "static/media/RosterIconGray.cbb29f4f061fe161eefab9646762e936.svg";
export { ForwardRef as ReactComponent };